import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import SeeAllLink from '../SeeAllLink';
import MoreByAuthor from '../MoreByAuthor';
import s from './SidebarBlockWrapper.scss';
var SidebarBlockWrapper = function (_a) {
    var deviation = _a.deviation, _b = _a.block, contentType = _b.contentType, seeAllType = _b.seeAllType, seeAllUrl = _b.seeAllUrl, titleType = _b.titleType, children = _a.children, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("div", { className: classnames(s['block-header'], titleType === 'plaintext' && s['original-title']) },
            React.createElement("span", { className: s['block-title'] }, titleType === 'more-by' && deviation.author ? (React.createElement(MoreByAuthor, { author: deviation.author, contentType: contentType })) : (t("sidebar.blockTitle." + contentType))),
            seeAllUrl && seeAllType && (React.createElement(SeeAllLink, { contentType: contentType, type: seeAllType, url: seeAllUrl, className: s['see-all'] }))),
        children));
};
SidebarBlockWrapper.displayName = 'SidebarBlockWrapper';
export default SidebarBlockWrapper;
//# sourceMappingURL=SidebarBlockWrapper.js.map